"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unset = exports.set = void 0;
/* eslint-disable @typescript-eslint/explicit-function-return-type */
const openfga_client_1 = require("./openfga-client");
const userMutations = (id) => ({
    owns: {
        contact: async (contactId) => {
            await (0, openfga_client_1.writeUniqueByObject)(`user:${id}`, "owns", `contact:${contactId}`);
        },
    },
    can_edit: {
        contact: async (contactId) => {
            await (0, openfga_client_1.write)(`user:${id}`, "can_edit", `contact:${contactId}`);
        },
        contacts: async (contactIds) => {
            await (0, openfga_client_1.batchWrite)(contactIds.map((contactId) => ({
                user: `user:${id}`,
                relation: "can_edit",
                object: `contact:${contactId}`,
            })));
        },
        note: async (noteId) => {
            await (0, openfga_client_1.write)(`user:${id}`, "can_edit", `note:${noteId}`);
        },
    },
    can_view: {
        contact: async (contactId) => {
            await (0, openfga_client_1.write)(`user:${id}`, "can_view", `contact:${contactId}`);
        },
    },
    has_elevated_access_in: {
        organization: async (orgId) => {
            await (0, openfga_client_1.write)(`user:${id}`, "elevated_access", `organization:${orgId}`);
        },
    },
    has_full_access_in: {
        organization: async (orgId) => {
            await (0, openfga_client_1.write)(`user:${id}`, "full_access", `organization:${orgId}`);
        },
    },
    can_edit_all_contacts_in: {
        organization: async (orgId) => {
            await (0, openfga_client_1.write)(`user:${id}`, "can_edit_all_contacts", `organization:${orgId}`);
        },
    },
    member: {
        organization: async (orgId) => {
            await (0, openfga_client_1.write)(`user:${id}`, "member", `organization:${orgId}`);
        },
    },
});
const usersMutations = (ids) => ({
    can_edit: {
        contact: async (contactId) => {
            await (0, openfga_client_1.batchWrite)(ids.map((id) => ({
                user: `user:${id}`,
                relation: "can_edit",
                object: `contact:${contactId}`,
            })));
        },
    },
});
const channelMutations = (channel) => ({
    for: {
        user: async (userId) => {
            await (0, openfga_client_1.writeUniqueByUser)(`user:${userId}`, "direct_subscriber", `channel:${channel}`);
            await (0, openfga_client_1.writeUniqueByUser)(`user:${userId}`, "direct_subscriber", "tier:basic", true);
        },
        organization: async (orgId) => {
            await (0, openfga_client_1.writeUniqueByUser)(`organization:${orgId}`, "subscriber", `channel:${channel}`);
            await (0, openfga_client_1.writeUniqueByUser)(`organization:${orgId}`, "subscriber", "tier:basic", true);
        },
        feature: async (featureName) => {
            await (0, openfga_client_1.writeUniqueByObject)(`channel:${channel}`, "associated_channel", `feature:${featureName}`);
        },
    },
});
const tierMutations = (tier) => ({
    for: {
        user: async (userId) => {
            await (0, openfga_client_1.writeUniqueByUser)(`user:${userId}`, "direct_subscriber", `tier:${tier}`);
            await (0, openfga_client_1.writeUniqueByUser)(`user:${userId}`, "direct_subscriber", "channel:stable", true);
        },
        organization: async (orgId) => {
            await (0, openfga_client_1.writeUniqueByUser)(`organization:${orgId}`, "subscriber", `tier:${tier}`);
            await (0, openfga_client_1.writeUniqueByUser)(`organization:${orgId}`, "subscriber", "channel:stable", true);
        },
        feature: async (featureName) => {
            await (0, openfga_client_1.writeUniqueByObject)(`tier:${tier}`, "associated_tier", `feature:${featureName}`);
        },
    },
});
const userUnsetters = (id) => ({
    can_edit: {
        contact: async (contactId) => {
            await (0, openfga_client_1.remove)(`user:${id}`, "can_edit", `contact:${contactId}`);
        },
    },
    can_view: {
        contact: async (contactId) => {
            await (0, openfga_client_1.remove)(`user:${id}`, "can_view", `contact:${contactId}`);
        },
    },
    has_elevated_access_in: {
        organization: async (orgId) => {
            await (0, openfga_client_1.remove)(`user:${id}`, "elevated_access", `organization:${orgId}`);
        },
    },
    has_full_access_in: {
        organization: async (orgId) => {
            await (0, openfga_client_1.remove)(`user:${id}`, "full_access", `organization:${orgId}`);
        },
    },
    can_edit_all_contacts_in: {
        organization: async (orgId) => {
            await (0, openfga_client_1.remove)(`user:${id}`, "can_edit_all_contacts", `organization:${orgId}`);
        },
    },
});
const orgMutations = (orgId) => ({
    for: {
        contact: async (contactId) => {
            await (0, openfga_client_1.writeUniqueByObject)(`organization:${orgId}`, "associated_organization", `contact:${contactId}`);
        },
    },
});
exports.set = {
    channel: channelMutations,
    tier: tierMutations,
    user: userMutations,
    users: usersMutations,
    organization: orgMutations,
};
exports.unset = {
    user: userUnsetters,
};
//# sourceMappingURL=setters.js.map